var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEndOfShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#FF525C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.173v.507h4V.667H6v.506M7.64 2.67c-.823.041-1.555.241-2.335.638C3.281 4.341 2 6.411 2 8.653c0 2.422 1.497 4.623 3.787 5.567 1.149.474 2.546.556 3.771.22 2.389-.655 4.168-2.754 4.414-5.209.08-.792-.014-1.747-.24-2.432-.104-.319-.453-1.032-.658-1.346a7.306 7.306 0 0 0-.338-.463l-.181-.224.422-.423.423-.423-.353-.353-.353-.353-.424.423-.424.423-.185-.147A6.014 6.014 0 0 0 9.286 2.79a6.123 6.123 0 0 0-1.646-.12m1.293 1.064c1.511.262 2.855 1.281 3.567 2.706.364.727.505 1.436.479 2.398-.016.589-.079.974-.235 1.442-.34 1.021-1.107 1.984-2.091 2.626-1.35.881-3.312.99-4.826.267-.519-.248-.963-.577-1.427-1.056-.697-.72-1.094-1.46-1.294-2.41-.086-.408-.12-1.235-.069-1.669.135-1.146.603-2.106 1.429-2.932A4.879 4.879 0 0 1 7.52 3.67c.298-.028 1.088.008 1.413.064m-3.68 2.199-.332.334 1.199 1.2 1.2 1.2-1.2 1.2-1.2 1.2.34.34.34.339 1.2-1.199 1.2-1.2 1.2 1.2 1.2 1.199.34-.339.34-.34-1.2-1.2-1.2-1.2 1.2-1.2 1.2-1.2-.34-.34-.34-.34-1.2 1.2L8 7.986 6.807 6.793A74.78 74.78 0 0 0 5.599 5.6c-.007 0-.163.15-.346.333",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndOfShift);
export default __webpack_public_path__ + "static/media/icon-end-of-shift.bac2103d8abddb1de8624f9f66ceda09.svg";
export { ForwardRef as ReactComponent };